// extracted by mini-css-extract-plugin
export default {"dot":"yjCeP","active":"Exl2W","container":"LmZkF"};